<ng-container *ngIf="lecture.public; else private">
  <button mat-icon-button (click)="onChange(!lecture.public, $event)">
    <mat-icon [ngClass]="{'public': lecture.public}" class="color-gray">lock_open</mat-icon>
  </button>
</ng-container>

<ng-template #private>
  <button mat-icon-button (click)="onChange(!lecture.public, $event)">
    <mat-icon class="color-gray">lock</mat-icon>
  </button>
</ng-template>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-public-button/lecture-public-button.component.html